<template>
  <div>
    <Nav className="navbar navbar-default navbar-mobile navbar-fixed bootsnav light" />
    <Banner :title="$t('footer.privacy')" />
    <Container file="privacy" />
    <Footer />
    <FollowModal />
    <SubscribeModal />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import Banner from '@/components/Banner.vue'
import Container from '@/components/Container.vue'
import Footer from '@/components/Footer.vue'
import FollowModal from '@/components/FollowModal.vue'
import SubscribeModal from '@/components/SubscribeModal.vue'

export default {
  name: 'privacy',
  data: function () {
  	return {
  	  
  	}
  },
  components: {
    Nav,
    Banner,
    Container,
    Footer,
    FollowModal,
    SubscribeModal
  },
  methods: {
    
  }
}
</script>
